import Page from "@modul-connect/shared/components/atoms/page"
import SearchWidget from "@modul-connect/shared/components/molecules/searchWidget"
import { Fragment, useState } from "react"
import { connect } from "react-redux"
import { addCode, addLogProvider, fetchLogCodes, fetchLogProviders, updateCode, updateLogProvider } from "../../../state/actions/logs"
import TableWidget from "@modul-connect/shared/components/molecules/tableWidgetv2"
import ModalAddReservation from "./modals/modalAddReservation"
import { MdEdit } from "react-icons/md"
import ModalEditReservation from "./modals/modalEditReservation"
import ModalAddCode from "./modals/modalAddCode"
import ModalEditCode from "./modals/modalEditCode"

export const LogCodes = ({ themes, logCodes, logCodeProviders, fetchLogCodes, fetchLogProviders, addLogProvider, updateLogProvider, addCode, updateCode, loading }) => {

  const [search, setSearch] = useState('')
  const [openModalAddReservation, setOpenModalAddReservation] = useState(false)
  const [openModalEditReservation, setOpenModalEditReservation] = useState(false)
  const [openModalAddCode, setOpenModalAddCode] = useState(false)
  const [openModalEditCode, setOpenModalEditCode] = useState(false)
  const [editingRowReservation, setEditingRowReservation] = useState(null)
  const [editingRowCode, setEditingRowCode] = useState([null,null])

  const onClickRowReservation = (row) => {
    setEditingRowReservation(row)
    setOpenModalEditReservation(true)
  }

  const onClickRowCode = (row) => {
    const providerInRange = logCodeProviders?.data.find(p => p.to_code >= row.code && p.from_code <= row.code)
    setEditingRowCode([row, providerInRange ? `${providerInRange?.provider} (${providerInRange?.section})`: null])
    setOpenModalEditCode(true)
  }

  const columnsCodes = [
    {
      id: 'code',
      label: 'Code',
      width: themes.device !== 'mobile' && 100,
      hide: []
    },
    {
      id: 'description',
      label: 'Description',
      hide: []
    },
    {
      id: 'edit',     
      label: '',       
      align: 'right',  
      width: 50,      
      hide: [],
      format: () => <MdEdit />
    }
  ]

  const columnsProviders = [
    {
      id: 'from_code',
      label: 'From',
      width: themes.device !== 'mobile' && 100,
      hide: []
    },
    {
      id: 'to_code',
      label: 'To',
      width: themes.device !== 'mobile' && 100,
      hide: []
    },
    {
      id: 'provider',
      label: 'Provider',
      width: themes.device !== 'mobile' && 120,
      hide: []
    },
    {
      id: 'section',
      label: 'Section',
      width: themes.device !== 'mobile' && 120,
      hide: []
    },
    {
      id: 'description',
      label: 'Description',
      hide: []
    },
    {
      id: 'edit',     
      label: '',       
      align: 'right',  
      width: 50,      
      hide: [],
      format: () => <MdEdit />
    }
  ]

  const statusCodes = loading.fetchLogCodes ? 'loading' : 'succeeded'; 
  const statusProviders = loading.fetchLogProviders ? 'loading' : 'succeeded'; 

  return (          
    <Fragment>
      <ModalEditCode
        openModal={openModalEditCode}
        onClose={() => {setOpenModalEditCode(false)}}
        onSubmit={() => {setOpenModalEditCode(false)}}
        existingRow={editingRowCode}
        editCode={updateCode}
      />
      <ModalAddCode
        openModal = {openModalAddCode}
        onClose={() => {setOpenModalAddCode(false)}}
        onSubmit={() => {setOpenModalAddCode(false)}}
        addCode={addCode}
      />
      <ModalEditReservation
        openModal = {openModalEditReservation}
        onClose = {() => setOpenModalEditReservation(false)}
        onSubmit = {() => setOpenModalEditReservation(false)}
        existingRow = {editingRowReservation}
        editReservation = {updateLogProvider}
      />
      <ModalAddReservation
        openModal = {openModalAddReservation}
        onClose = {() => setOpenModalAddReservation(false)}
        onSubmit = {() => setOpenModalAddReservation(false)}
        addReservation = {addLogProvider}
      />
      <Page title='Codes' linkTitle={'Add Code'} onClickLink={() => setOpenModalAddCode(true)}>
        <SearchWidget
          placeholder='Search for log codes...'
          initialValue={ "" }
          onChange={ event => setSearch(event.target.value) }
        />    
        <TableWidget
          themes={ themes }
          columns={ columnsCodes }
          data={ logCodes.data || [] }
          onFetchData={ fetchLogCodes }
          loadingStatus={ statusCodes }
          searchStr={ search }
          isSortable={ true }
          defaultSort={'code'}
          hide={ false }
          totalItems={ logCodes.data ? logCodes.data.length : 0 }
          rowsOptions={[10, 25, 50, 100]}
          defaultRowsPerPage={25}
          onClickRow={(event, rowId, row) => onClickRowCode(row)}
        />
      </Page>
      <Page title='Code Providers' linkTitle={'Add Reservation'} onClickLink={() => setOpenModalAddReservation(true)}>
        <TableWidget
          themes={ themes }
          columns={ columnsProviders }
          data={ logCodeProviders.data || [] }
          onFetchData={ fetchLogProviders }
          loadingStatus={ statusProviders }
          isSortable={ true }
          defaultSort={'from_code'}
          hide={ false }
          totalItems={ logCodeProviders.data ? logCodeProviders.data.length : 0 }
          rowsOptions={[10, 25, 50, 100]}
          defaultRowsPerPage={25}
          onClickRow={(event, rowId, row) => onClickRowReservation(row)}
        />
      </Page>
    </Fragment>
    )
}

const mapStateToProps = ({
  themes,
  logCodes,
  logCodeProviders,
  loading
}) => ({
  themes,
  logCodes,
  logCodeProviders,
  loading
})

const mapDispatchToProps = dispatch => ({
  fetchLogCodes: () => dispatch(fetchLogCodes()),
  fetchLogProviders: () => dispatch(fetchLogProviders()),
  addLogProvider: (data) => dispatch(addLogProvider(data)),
  updateLogProvider: (data) => dispatch(updateLogProvider(data)),
  addCode: (data) => dispatch(addCode(data)),
  updateCode: (data) => dispatch(updateCode(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(LogCodes)